import { Tooltip } from '@material-ui/core'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import { withTranslation } from 'react-i18next'

const InfoWithTooltip = ({ text, tooltipContent, t, placement = 'top' }) => {
  const renderTooltipContent = () => {
    if (typeof tooltipContent === 'string') {
      return tooltipContent
    }

    if (tooltipContent?.title && tooltipContent?.subtitle) {
      return (
        <div>
          <strong>{t(tooltipContent.title)}</strong>
          <br />
          {t(tooltipContent.subtitle)}
        </div>
      )
    }

    return tooltipContent
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <span>{text}</span>
      <Tooltip
        title={renderTooltipContent()}
        placement={placement}
        classes={{
          tooltip: 'custom-tooltip'
        }}
      >
        <InfoOutlined
          style={{ fill: 'rgba(0, 0, 0, 0.38)', cursor: 'pointer' }}
          fontSize="small"
        />
      </Tooltip>
    </div>
  )
}

export default withTranslation()(InfoWithTooltip)
